







import Vue from 'vue'
import TransactionsView from '@/components/TransactionsView.vue'
import { BalanceTransactionsType } from '@/api/Agency/agency.interface'
import { balanceTransactionsController } from '@/api/Agency/agency.api'

export default Vue.extend({
  components: {
    TransactionsView,
  },
  data() {
    return {
      // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
      // @ts-ignore
      types: this.$utils.makeSelectable(BalanceTransactionsType),
      controller: balanceTransactionsController,
    }
  },
})
